<template>
  <div :class="(content.playerInline === 1 || content.noMargin === 1) ? '' : 'content_w_710'" :id="content.key">
    <template v-if="content.playerInline === 1">
      <component :is="inlineComponentsName[content.type]" v-for="item in content.content" :key="item.key" :content="item" :styleType="content.styleType"></component>
    </template>
    <component v-else :is="componentsName[content.type]" v-for="item in content.content" :key="item.key" :content="item" :styleType="content.styleType"></component>
    
    <!-- <imageUnit v-for="item in content.content" :key="item.key" :content="item" :canSetWidth="true"></imageUnit> -->
  </div>
</template>

<script>
/*
板式-1 单个展示
*/
import imageUnit from "../unit/image.vue";
import videoUnit from "../unit/video.vue";
import audioUnit from "../unit/audio.vue";
import threeDUnit from "../unit/three-D.vue";
import videoInlineUnit from "../unit/video-inline.vue";
import audioInlineUnit from "../unit/audio-inline.vue";

export default {
  name: "mediaTemplate1",
  components: {
    imageUnit,
    videoUnit,
    audioUnit,
    threeDUnit,
    videoInlineUnit,
    audioInlineUnit,
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      inlineComponentsName: {
        'video': 'videoInlineUnit',
        'audio': 'audioInlineUnit',
      },
      componentsName: {
        'image': 'imageUnit',
        'video': 'videoUnit',
        'audio': 'audioUnit',
        '3DModel': 'threeDUnit',
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content_w_710 {
  width: calc(100% - 48rem);
  margin: 0 auto 20px;
}
</style>